import { createSelector } from 'reselect';
import { ApplicationState } from '../types';

export const getEditModeBank = ({ editModeBank }: ApplicationState) =>
  editModeBank;

export const getBankEditMode = createSelector(
  [getEditModeBank],
  (editModeBank) => editModeBank.editModeFlag
);
